import React, { useState } from "react";
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { classNames } from 'primereact/utils';
import { Password } from 'primereact/password';
import { Divider } from 'primereact/divider';
import { Panel } from 'primereact/panel';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { RadioButton } from "primereact/radiobutton";
import {
    Form,
    useSubmit,
    useLoaderData,
} from "react-router-dom";
import { useFormik } from 'formik';
import { getUserProfile, updateUser, resetPwd, sendOnboardingStripeMail } from "../../../data/admin/userProfiles";
import { send, notify } from "../../../services/NotificationService";
export async function loader({ params }) {
    const acc = await getUserProfile(params.userId);

    return { acc };
}

export default function UserUpdate() {
    const { acc } = useLoaderData();
    const [value, setValue] = useState('');
    const header = <div className="font-bold mb-3">Choisir un mot de passe</div>;

    const footer = (
        <>
            <Divider />
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>Au moins une minuscule</li>
                <li>Au moins une majuscule</li>
                <li>Au moins un chiffre</li>
                <li>Au moins un caractère non-alphanumérique</li>
                <li>Minimum 6 caractères</li>
            </ul>
        </>
    );



    var email, address, zipcode, city, phone, fname, lname, isProfessional, companyName, siret, vatNumber;
    if (acc) {
        email = acc.email;
        address = acc.address;
        zipcode = acc.zipcode;
        city = acc.city;
        phone = acc.phone;
        fname = acc.firstname;
        lname = acc.lastname;
        isProfessional = acc.isProfessional;
        companyName = acc.companyName;
        siret = acc.siret;
        vatNumber = acc.vatNumber;
    }

    // Formik ---------------------
    const submit = useSubmit();
    const formik = useFormik({
        initialValues: {
            email: email ?? '',
            newPwd: '',
            address: address ?? '',
            zipcode: zipcode ?? '',
            city: city ?? '',
            phone: phone ?? '',
            fname: fname ?? '',
            lname: lname ?? '',
            isProfessional: isProfessional ?? false,
            companyName: companyName ?? '',
            siret: siret ?? '',
            vatNumber: vatNumber ?? ''
        },
        validate: (data) => {
            let errors = {};

            return errors;
        },
        onSubmit: async (data) => {
            submit(data, { method: "post" })
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    //----------------------------------------
    
    const resetPwdAction = () => {
        let a = resetPwd({ Password: formik.values.newPwd }, acc.userPublicId);
        a.then((a) => {
            if (a.status === 200)
                send("success", a.message)
            else
                send("error", a.message)

            notify();
        });
    };


    const UpdateAction = () => {
        let email = document.getElementById('email').value;
        let fname = document.getElementById('fname').value;
        let lname = document.getElementById('lname').value;
        let address = document.getElementById('address').value;
        let zipcode = document.getElementById('zipcode').value;
        let city = document.getElementById('city').value;
        let phone = document.getElementById('phone').value;

        let params = {
            Email: email,
            Firstname: fname,
            Lastname: lname,
            Address: address,
            City: city,
            Zipcode: zipcode,
            Phone: phone,
            IsProfessional: formik.values.isProfessional === true || formik.values.isProfessional === "true",
            CompanyName: formik.values.companyName,
            Siret: formik.values.siret,
            VatNumber: formik.values.vatNumber
        };
        let a = updateUser(params, acc.userPublicId);
        a.then((a) => {
            if (a.status === 200)
                send("success", a.message)
            else
                send("error", a.message)

            notify();
        });
    };

    const refreshGeolocationAction = () => {
        let address = document.getElementById('address').value;
        let zipcode = document.getElementById('zipcode').value;
        let city = document.getElementById('city').value;

        let params = {
            Address: address,
            City: city,
            Zipcode: zipcode
        };

        let a = updateUser(params, acc.userPublicId);
        a.then((a) => {
            if (a.status === 200)
                send("success", "La géolocalisation a été recalculée.")
            else
                send("error", a.message)

            notify();
        });
    };



    const sendOnbardingMail = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Êtes-vous sûr de vouloir envoyer le mail ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept,
            reject
        });
    };

    const accept = () => {
        let a = sendOnboardingStripeMail(acc.userPublicId);
        a.then((a) => {
            if (a.status === 200)
                send("success", a.message)
            else
                send("error", a.message)
            notify();
        });

    };

    const reject = () => {
    };

    return (
        <div >
            <h1>Compte de {acc.firstname + " " + acc.lastname}</h1>

            <Form method="post" id="thumbnail-form" onSubmit={formik.handleSubmit}>
                <Panel header="Identit&eacute;">
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText id="fname" name="fname" value={formik.values.fname}
                                onChange={(e) => {
                                    formik.setFieldValue('fname', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('fname') })}
                            />
                            <label htmlFor="fname">Pr&eacute;nom</label>
                        </span>

                        <span className="p-float-label">
                            <InputText id="lname" name="lname" value={formik.values.lname}
                                onChange={(e) => {
                                    formik.setFieldValue('lname', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('lname') })}
                            />
                            <label htmlFor="lname">Nom</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="email" name="email" value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue('email', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('email') })}
                            />
                            <label htmlFor="email">Email</label>
                        </span>
                    </div>
                    <div className="contentForm"></div >
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText id="address" name="address" value={formik.values.address}
                                onChange={(e) => {
                                    formik.setFieldValue('address', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('address') })}
                            />
                            <label htmlFor="address">Num&eacute;ro et rue</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="zipcode" name="zipcode" value={formik.values.zipcode}
                                onChange={(e) => {
                                    formik.setFieldValue('zipcode', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('zipcode') })}
                            />
                            <label htmlFor="zipcode">Code Postal</label>
                        </span>
                        <span className="p-float-label">
                            <InputText id="city" name="city" value={formik.values.city}
                                onChange={(e) => {
                                    formik.setFieldValue('city', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('city') })}
                            />
                            <label htmlFor="city">Ville</label>
                        </span>
                        <span className="p-float-label">
                            <Button size="small" type="button" onClick={() => refreshGeolocationAction()} severity="secondary">Recalculer la géolocalisation</Button>
                        </span>
                    </div>
                    <div className="contentForm">
                        <span className="p-float-label">
                            <InputText id="phone" name="phone" value={formik.values.phone}
                                onChange={(e) => {
                                    formik.setFieldValue('phone', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('phone') })}
                            />
                            <label htmlFor="phone">T&eacute;l&eacute;phone</label>
                        </span>
                        <span className="p-float-label">
                            <Button size="small" type="button" onClick={() => UpdateAction()} severity="secondary">Enregistrer !</Button>
                        </span>
                    </div>
                    <div className="contentForm">
                        <div className="flex align-items-center">
                            <RadioButton inputId="account-type-private" name="isProfessional" value={false} onChange={(e) => {
                                formik.setFieldValue('isProfessional', e.value);
                            }} checked={formik.values.isProfessional === false || formik.values.isProfessional === "false"} />
                            <label htmlFor="account-type-private" className="ml-2">Particulier</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="account-type-professional" name="isProfessional" value={true} onChange={(e) => {
                                formik.setFieldValue('isProfessional', e.value);
                            }} checked={formik.values.isProfessional === true || formik.values.isProfessional === "true"} />
                            <label htmlFor="account-type-professional" className="ml-2">Professionnel</label>
                        </div>
                    </div>
                    {(formik.values.isProfessional === true || formik.values.isProfessional === "true") && (
                        <div className="contentForm">
                            <span className="p-float-label">
                                <InputText id="companyName" name="companyName" value={formik.values.companyName}
                                    onChange={(e) => {
                                        formik.setFieldValue('companyName', e.target.value);
                                    }}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('companyName') })}
                                />
                                <label htmlFor="companyName">Raison sociale</label>
                            </span>
                            <span className="p-float-label">
                                <InputText id="siret" name="siret" value={formik.values.siret}
                                    onChange={(e) => {
                                        formik.setFieldValue('siret', e.target.value);
                                    }}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('siret') })}
                                />
                                <label htmlFor="siret">SIRET</label>
                            </span>
                            <span className="p-float-label">
                                <InputText id="vatNumber" name="vatNumber" value={formik.values.vatNumber}
                                    onChange={(e) => {
                                        formik.setFieldValue('vatNumber', e.target.value);
                                    }}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('vatNumber') })}
                                />
                                <label htmlFor="vatNumber">TVA intracommunautaire</label>
                            </span>
                        </div>
                    )}
                    
                    <div className="contentForm"></div >
                </Panel>
                <div className="contentForm"></div >
                <Panel header="Mot de passe">
                    <div className="contentForm">
                       
                        <div className="card flex justify-content-center">
                            <span className="p-float-label">

                                <Password id="newPwd" name="newPwd" value={formik.values.newPwd} header={header} footer={footer}
                                    promptLabel=" " weakLabel="Trop simple" mediumLabel="Moyennement complexe" strongLabel="Très complexe !"

                                    onChange={(e) => {
                                        formik.setFieldValue('newPwd', e.target.value);
                                        setValue(e.target.value)
                                    }}
                                    className={classNames({ 'p-invalid': isFormFieldInvalid('newPwd') })}
                                />
                                <label htmlFor="newPwd">Nouveau</label>
                            </span>
                            <span className="p-float-label">
                                <Button size="small" type="button" onClick={() => resetPwdAction()} severity="secondary">Reset !</Button>
                            </span>
                        </div>
                       
                    </div>
                    <div className="contentForm"></div >
                </Panel>
                <div className="contentForm"></div >

                <div > <div className="contentForm"></div >


                   
              
                    <div className="contentForm"></div >
                    <Panel header="Compte Stripe">
                        <div className="contentForm">
                            
                            <ConfirmPopup />
                            
                            {(acc.stripeStatus === "NeedToCreateAccount") &&
                                <span >Compte à créer</span>
                            }
                            {(acc.stripeStatus === "NeedToCompleteAccount") &&
                                <span >Compte à compléter</span>
                            }
                            {(acc.stripeStatus === "AccountCreated") &&
                                <span >Connected Account Id : {acc.stripeAccountId}</span>
                            }
                               
                            <div className="contentForm"></div >
                            
                        </div>
                        <div className="contentForm"><Button onClick={sendOnbardingMail} type="button" size="small" severity="secondary" >Envoyer le mail de relance</Button></div >
                        <div className="contentForm"></div >
                    </Panel>
                    <div className="contentForm"></div >
                </div >
            </Form>
        </div>
    );
}
